// import { QueryCache } from "react-query";

import { QueryCache } from '@tanstack/react-query';

const apiURL = process.env.REACT_APP_API_URL;
// const apiURL = 'https://minutesapi.theminutesapp.com';

const queryCache = new QueryCache({
  onError: error => {
    console.log(error);
  },
  onSuccess: data => {
    console.log(data);
  },
});

// async function client(
//   endpoint,
//   { data, headers: customHeaders, ...customConfig } = {}
// ) {
//   const token = localStorage.getItem('token');
//   const config = {
//     method: data ? 'POST' : 'GET',
//     body: data instanceof FormData ? data : JSON.stringify(data),
//     headers: {
//       Authorization:
//         token || data?.forgetToken ? `${token || data?.forgetToken}` : '',
//       ...(!data || data instanceof FormData
//         ? {}
//         : { 'Content-Type': 'application/json' }),

//       ...customHeaders,
//     },
//     ...customConfig,
//   };

//   return await window
//     .fetch(`${apiURL}/${endpoint}`, config)
//     .then(async response => {
//       // const body = response.json();
//       if (response.status === 401) {
//         localStorage.clear();
//         queryCache.clear();
//         return await Promise.reject({ message: 'Please re-authenticate.' });
//       }

//       if (response.ok) {
//         const jsonData = await response.json(); // Await the JSON parsing
//         return jsonData;
//       } else {
//         const jsonData = await response.json(); // Await the JSON parsing
//         return await Promise.reject(jsonData);
//       }
//     });
// }
async function client(
  endpoint,
  { data, headers: customHeaders, ...customConfig } = {}
) {
  const token = localStorage.getItem('token');
  const config = {
    method: data ? 'POST' : 'GET',
    body: data instanceof FormData ? data : JSON.stringify(data),
    headers: {
      Authorization:
        token || data?.forgetToken
          ? `Bearer ${token || data?.forgetToken}` // Add "Bearer" prefix here
          : '',

      ...(!data || data instanceof FormData
        ? {}
        : { 'Content-Type': 'application/json' }),

      ...customHeaders,
    },
    ...customConfig,
  };

  return await window
    .fetch(`${apiURL}/${endpoint}`, config)
    .then(async response => {
      let responseData = null;
      try {
        const responseClone = response.clone();
        responseData = await responseClone.json();
      } catch (parseError) {
        // If parsing fails, keep responseData as null and use defaults later
        console.warn('Failed to parse response JSON:', parseError);
      }

      const buildErrorPayload = fallbackMessage => {
        if (responseData && typeof responseData === 'object') {
          if (!responseData.message && responseData.detail) {
            return { ...responseData, message: responseData.detail };
          }
          return responseData;
        }
        return { message: fallbackMessage };
      };

      if (response.status === 401) {
        localStorage.clear();
        queryCache.clear();
        return await Promise.reject(
          buildErrorPayload('Please re-authenticate.')
        );
      }

      if (response.ok) {
        return responseData ?? {};
      }

      return await Promise.reject(
        buildErrorPayload('Request failed. Please try again.')
      );
    });
}

export { client };
